import React from 'react';

/**
 * Runs an internal chip event handler before an optional consumer handler.
 */
export const composeChipEventHandlers =
    <Event extends React.SyntheticEvent>(...handlers: Array<React.EventHandler<Event> | undefined>) =>
    (event: Event) => {
        handlers.forEach((handler) => handler?.(event));
    };
